import axios from "axios";

const ErectionMonitorService = {
  GetUnits: () =>
    axios.get("ErecMonitor/GetUnits"),

  GetFabTypes: () =>
    axios.get("ErecMonitor/GetFabTypes"),

  // contribution % of each fabrication type for a unit
  GetWeights: (unitId) =>
    axios.get("ErecMonitor/GetWeights", { params: { unitId } }),

  // saved target dates of an IWO + unit
  GetUnitFabrications: (iwoNo, unitId) =>
    axios.get("ErecMonitor/GetUnitFabrications", { params: { iwoNo, unitId } }),

  // targets go as fabrications[0].typeId / fabrications[0].targetDate
  InsertTargetDates: (payload) => {
    const body = new URLSearchParams();
    body.append("iwoNo", payload.iwoNo);
    body.append("unitId", payload.unitId);
    body.append("createdBy", payload.createdBy);
    (payload.fabrications || []).forEach((f, i) => {
      body.append(`fabrications[${i}].typeId`, f.typeId);
      body.append(`fabrications[${i}].targetDate`, f.targetDate);
    });

    return axios.post("ErecMonitor/InsertTargetDates", body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },

  UpdateTargetDates: (payload) => {
    const body = new URLSearchParams();
    body.append("iwoNo", payload.iwoNo);
    body.append("unitId", payload.unitId);
    // componentId comes from GetUnitFabrications (Data.ComponentId)
    if (payload.componentId !== null && payload.componentId !== undefined && payload.componentId !== "") {
      body.append("componentId", payload.componentId);
    }
    body.append("updatedBy", payload.updatedBy);
    (payload.fabrications || []).forEach((f, i) => {
      if (f.progressId) body.append(`fabrications[${i}].progressId`, f.progressId);
      body.append(`fabrications[${i}].typeId`, f.typeId);
      body.append(`fabrications[${i}].targetDate`, f.targetDate);
    });

    return axios.post("ErecMonitor/UpdateTargetDates", body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },

  // CDL + DTS delay reasons (same structure as PreFabMonitor/GetDelayReasons)
  GetDelayReasons: () =>
    axios.get("ErecMonitor/GetDelayReasons"),

  // GetDailyRemarks?iwoNo=10145 (all units of the IWO), ?componentId=1 (IWO + unit) or ?progressId=2 (one stage)
  GetDailyRemarks: ({ iwoNo, progressId, componentId } = {}) => {
    const params = {};
    if (iwoNo) params.iwoNo = iwoNo;
    if (progressId) params.progressId = progressId;
    if (componentId) params.componentId = componentId;
    return axios.get("ErecMonitor/GetDailyRemarks", { params });
  },

  // Only the given fields are sent (empty ones are left out)
  InsertDailyRemark: (payload) => {
    const body = new URLSearchParams();
    body.append("progressId", payload.progressId);
    ["remarkDate", "commonRemark", "lostHoursCdl", "lostHoursDts", "reasonCdl", "reasonDts", "remarkCdl", "remarkDts", "completionStatus", "physicalCompletion"].forEach((key) => {
      if (payload[key] !== undefined && payload[key] !== null && payload[key] !== "") body.append(key, payload[key]);
    });
    body.append("createdBy", payload.createdBy);

    return axios.post("ErecMonitor/InsertDailyRemark", body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },

  // dailyId (+ progressId, remarkDate) find the remark; only the changed fields are sent
  UpdateDailyRemark: (payload) => {
    const body = new URLSearchParams();
    if (payload.dailyId) body.append("dailyId", payload.dailyId); 
    body.append("progressId", payload.progressId);
    ["remarkDate", "commonRemark", "lostHoursCdl", "lostHoursDts", "reasonCdl", "reasonDts", "remarkCdl", "remarkDts", "completionStatus", "physicalCompletion"].forEach((key) => {
      if (payload[key] !== undefined && payload[key] !== null) body.append(key, payload[key]);
    });
    body.append("updatedBy", payload.updatedBy);

    return axios.post("ErecMonitor/UpdateDailyRemark", body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
};

export default ErectionMonitorService;